import { createFileRoute } from "@tanstack/react-router";
import { InviteView } from "./-InviteView";

function InviteRoute() {
  const { token } = Route.useParams();
  return <InviteView token={token} />;
}

export const Route = createFileRoute("/invite/$token")({
  component: InviteRoute,
});
